import { Box, Flex } from '@chakra-ui/react'

import { AccordionItem, AccordionItemContent, AccordionItemTrigger, AccordionRoot } from '@/components/ui/accordion'
import useColorModeValue from '@/hooks/useColorModeValue'
import { IApproval, IApprovalDetail, ICompliance, ITaskDetail } from '@/types/tasksApprovals'
import { isTNE } from '@/utils/approvals'
import { generateFieldsByType } from '@/utils/approvalsFileds'

const Container = ({ item, itemDetails }: { item: ICompliance | IApproval; itemDetails: ITaskDetail | IApprovalDetail }) => {
    const moreDetailsFields = itemDetails.fields.filter((field) => field.section !== 'default')
    const backgroundColor = useColorModeValue('rgba(84, 79, 64, 0.08)', 'rgba(190, 190, 189, 0.08)')
    return (
        <Box py="8px" px="24px">
            <AccordionRoot multiple>
                <AccordionItem value="highlighted" border="none" width="100%">
                    <Flex>
                        <AccordionItemTrigger
                            _hover={{
                                background: 'transparent',
                            }}
                            p="0"
                            fontSize={12}
                        >
                            {moreDetailsFields[0].section}
                        </AccordionItemTrigger>
                    </Flex>
                    <AccordionItemContent
                        pl="0"
                        py="8px"
                        mt="16px"
                        fontSize="14px"
                        letterSpacing="0.25px"
                        backgroundColor={backgroundColor}
                    >
                        <Box display={isTNE(item) ? 'flex' : 'block'} justifyContent={'flex-start'}>
                            {moreDetailsFields.map((field) => (
                                <Box position="relative" key={field.name}>
                                    {generateFieldsByType(field, item)}
                                </Box>
                            ))}
                        </Box>
                    </AccordionItemContent>
                </AccordionItem>
            </AccordionRoot>
        </Box>
    )
}

export default Container
